import { stdObject } from "../../../../data/types/stdObject";
import { getMode } from "../data/searchItemUtils";
import { colors } from "../../../../data/colors";
import SearchInputType from "./SearchInputType";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import useSearchModule from "./useSearchModule";

export default function SearchModule({
  data = {},
  sortList = null,
}: {
  data: stdObject;
  sortList?: stdObject | null;
}) {
  const { type, tempData, CODCAB, TITCAB, MSECAB, changeValue, getValue } =
    useSearchModule({
      data,
    });

  return (
    <>
      <div style={{ padding: 3 }}>
        <SearchInputType
          data={sortList ?? tempData}
          code={!!sortList ? "SORT" : CODCAB}
          TITCAB={TITCAB}
          changeValue={changeValue}
          getValue={getValue}
        />
      </div>
      {MSECAB &&
        ["text", "number"].includes(tempData.type) &&
        "mode" in tempData && (
          <div
            className="searchTitle"
            style={{
              color: colors[type],
            }}
          >
            <div
              style={{ cursor: "pointer" }}
              onClick={() =>
                changeValue({
                  key: !!sortList ? "SORT" : CODCAB,
                  value: !!sortList
                    ? getValue("mode", "SORT")
                    : getValue("mode") + 1,
                  valueKey: "mode",
                })
              }
            >
              {!!sortList ? (
                <div className="sortIconBox">
                  {getValue("mode", "SORT") === "1" ? (
                    <ArrowUpwardIcon
                      className="sortIcon"
                      style={{
                        position: "absolute",
                        fontSize: 20,
                        left: -2,
                        top: 1,
                      }}
                    />
                  ) : (
                    <ArrowDownwardIcon
                      className="sortIcon"
                      style={{
                        position: "absolute",
                        fontSize: 20,
                        left: -2,
                        top: 1,
                      }}
                    />
                  )}
                </div>
              ) : (
                getMode(getValue("mode"))
              )}
            </div>
          </div>
        )}
    </>
  );
}
